<template>
  <div class="carousel_wrap">
    <!-- 桌面端视频轮播 -->
    <div class="video-carousel hidden-xs-only">
      <div class="video-container">
        <video 
          v-if="videoUrl"
          :src="videoUrl" 
          class="video_item"
          autoplay
          muted
          loop
          playsinline
        ></video>
      </div>
    </div>
    
    <!-- 移动端视频轮播 -->
    <div class="video-carousel hidden-sm-and-up">
      <div class="video-container">
        <video 
          v-if="videoUrl"
          :src="videoUrl" 
          class="video_item"
          autoplay
          muted
          loop
          playsinline
        ></video>
      </div>
    </div>
  </div>
</template>

<script>
import { getHomeBanner } from '../../api/system'

export default {
  data() {
    return {
      videoUrl: ''
    }
  },
  methods: {
    async getHomeBannerFunc() {
      try {
        const language = this.$i18n.locale || 'zh-CN'
        const res = await getHomeBanner(language)
        console.log('轮播图API响应:', res)
        
        if (res.data && res.data.success && res.data.data && res.data.data.length > 0) {
          // 只取第一个视频项目
          const firstItem = res.data.data[0]
          // 优先使用videoUrl，如果没有则使用imageUrl
          this.videoUrl = firstItem.videoUrl || firstItem.imageUrl || ''
        } else {
          console.warn('API did not return banner data, using default video.')
          this.useDefaultVideo()
        }
      } catch (error) {
        console.error('Failed to fetch carousel data:', error)
        this.useDefaultVideo()
      }
    },

    // 使用默认视频
    useDefaultVideo() {
      // 这里可以设置一个默认的视频URL
      this.videoUrl = '/files/2025/10/1761643216575_ae563b71.webm'
    }
  },
  mounted() {
    this.getHomeBannerFunc()
  },
  watch: {
    '$i18n.locale': function() {
      this.getHomeBannerFunc()
    }
  }
}
</script>

<style lang="scss" scoped>
.carousel_wrap {
  position: relative;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;

  .video-carousel {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    
    .video-container {
      width: 100%;
      height: 100%;
      position: relative;
      margin: 0;
      padding: 0;
      
      .video_item {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        margin: 0;
        padding: 0;
        background-color: #000;
      }
    }
  }

  .tips_font {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 5;
    color: #fff;
    text-align: center;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7);
    width: 80%;
    max-width: 800px;
    pointer-events: none;

    h1 {
      font-size: 2.5rem;
      margin-bottom: 1rem;
      font-weight: 700;
    }

    p {
      font-size: 1.2rem;
      margin-bottom: 2rem;
      line-height: 1.6;
    }

    .carousel-button {
      display: inline-block;
      padding: 12px 24px;
      border: 2px solid #fff;
      color: #fff;
      text-decoration: none;
      border-radius: 5px;
      font-size: 1rem;
      font-weight: 600;
      pointer-events: auto;
      transition: all 0.3s ease;
      background-color: transparent;

      &:hover {
        background-color: #fff;
        color: #000;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
      }
    }

    @media screen and (max-width: 768px) {
      width: 90%;
      h1 {
        font-size: 1.8rem;
      }
      p {
        font-size: 1rem;
      }
      .carousel-button {
        padding: 10px 20px;
        font-size: 0.9rem;
      }
    }
  }
}

// 响应式隐藏类
.hidden-xs-only {
  @media screen and (max-width: 767px) {
    display: none !important;
  }
}

.hidden-sm-and-up {
  @media screen and (min-width: 768px) {
    display: none !important;
  }
}
</style>
